// extracted by mini-css-extract-plugin
export default {"warning":"ImageManipulationTabContent_warning__uflbd","infoIcon":"ImageManipulationTabContent_infoIcon__2R7AX"};